import React from 'react';
import Yoga__default, { ALIGN_AUTO, ALIGN_BASELINE, ALIGN_CENTER, ALIGN_FLEX_END, ALIGN_FLEX_START, ALIGN_SPACE_AROUND, ALIGN_SPACE_BETWEEN, ALIGN_STRETCH, DISPLAY_NONE, DISPLAY_FLEX, FLEX_DIRECTION_COLUMN, FLEX_DIRECTION_COLUMN_REVERSE, FLEX_DIRECTION_ROW, FLEX_DIRECTION_ROW_REVERSE, WRAP_NO_WRAP, WRAP_WRAP, WRAP_WRAP_REVERSE, JUSTIFY_CENTER, JUSTIFY_FLEX_END, JUSTIFY_FLEX_START, JUSTIFY_SPACE_AROUND, JUSTIFY_SPACE_BETWEEN, JUSTIFY_SPACE_EVENLY, Node } from 'yoga-layout-prebuilt';
import { Util } from '@antv/g6-core';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _excluded = ["children"];
var Group = function Group(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'group'
    })
  }, children);
};

var _excluded$1 = ["children"];
var Circle = function Circle(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$1);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'circle'
    })
  }, children);
};

var _excluded$2 = ["children"];
var Ellipse = function Ellipse(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$2);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'ellipse'
    })
  }, children);
};

var _excluded$3 = ["children"];
var Image = function Image(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$3);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'image'
    })
  }, children);
};

var _excluded$4 = ["children"];
var Marker = function Marker(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$4);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'marker'
    })
  }, children);
};

var _excluded$5 = ["children"];
var Polygon = function Polygon(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$5);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'polygon'
    })
  }, children);
};

var _excluded$6 = ["children"];
var Rect = function Rect(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$6);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'rect'
    })
  }, children);
};

var _excluded$7 = ["children"];
var Path = function Path(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$7);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'path'
    })
  }, children);
};

var _excluded$8 = ["children"];
var Text = function Text(props) {
  // @ts-ignore
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded$8);
  return React.createElement("div", {
    "data-attr": _objectSpread2(_objectSpread2({}, rest), {}, {
      type: 'text'
    })
  }, children);
};

var _excluded$9 = ["style", "type"];
var getShapeFromReact = function getShapeFromReact(REl) {
  if (typeof REl === 'string') {
    return REl;
  }
  if (typeof REl.type === 'string') {
    var data = REl.props['data-attr'] || {};
    var _data$style = data.style,
      attrs = _data$style === void 0 ? {} : _data$style,
      type = data.type,
      props = _objectWithoutProperties(data, _excluded$9);
    var ochildren = REl.props.children;
    if (type === 'text') {
      attrs.text = (ochildren === null || ochildren === void 0 ? void 0 : ochildren.join) ? ochildren.join('') : ochildren;
      return {
        type: type,
        attrs: attrs,
        props: props,
        children: []
      };
    }
    var children = [];
    if (_typeof(ochildren) === 'object' && (ochildren === null || ochildren === void 0 ? void 0 : ochildren.length)) {
      children = ochildren.filter(function (e) {
        return !!e;
      }).reduce(function (a, b) {
        return a.concat(b.concat ? b : [b]);
      }, []).map(function (e) {
        return getShapeFromReact(e);
      });
    } else if (ochildren) {
      children = [getShapeFromReact(ochildren)];
    }
    return {
      type: type,
      attrs: attrs,
      props: props,
      children: children
    };
  } else {
    var Element = REl.type;
    try {
      return getShapeFromReact(new Element(_objectSpread2({}, REl.props)));
    } catch (e) {
      return getShapeFromReact(Element(_objectSpread2({}, REl.props)));
    }
  }
};

var XYPath = ['L', 'M', 'C', 'S', 'Q', 'T', 'V'];
var xyPath = XYPath.map(function (e) {
  return e.toLocaleLowerCase();
});
var convertPathToPoints = function convertPathToPoints(path) {
  var points = [];
  path.forEach(function (seg) {
    var _seg = _toArray(seg),
      command = _seg[0],
      numbers = _seg.slice(1);
    var _points$slice = points.slice(-1),
      _points$slice2 = _slicedToArray(_points$slice, 1),
      lastPoint = _points$slice2[0];
    if (!lastPoint) {
      lastPoint = [0, 0];
    }
    if (XYPath.includes(command)) {
      var _numbers$slice = numbers.slice(-2),
        _numbers$slice2 = _slicedToArray(_numbers$slice, 2),
        x = _numbers$slice2[0],
        y = _numbers$slice2[1];
      points.push([x, y]);
    } else if (xyPath.includes(command)) {
      var _numbers$slice3 = numbers.slice(-2),
        _numbers$slice4 = _slicedToArray(_numbers$slice3, 2),
        _x = _numbers$slice4[0],
        _y = _numbers$slice4[1];
      points.push([_x + lastPoint[0], _y + lastPoint[1]]);
    } else if (command === 'H') {
      var _numbers$slice5 = numbers.slice(-1),
        _numbers$slice6 = _slicedToArray(_numbers$slice5, 1),
        _x2 = _numbers$slice6[0];
      points.push([_x2, lastPoint[0]]);
    } else if (command === 'h') {
      var _numbers$slice7 = numbers.slice(-1),
        _numbers$slice8 = _slicedToArray(_numbers$slice7, 1),
        _x3 = _numbers$slice8[0];
      points.push([_x3 + lastPoint[0], lastPoint[1]]);
    } else if (command === 'V') {
      var _numbers$slice9 = numbers.slice(-1),
        _numbers$slice10 = _slicedToArray(_numbers$slice9, 1),
        _y2 = _numbers$slice10[0];
      points.push([lastPoint[0], _y2]);
    } else if (command === 'v') {
      var _numbers$slice11 = numbers.slice(-1),
        _numbers$slice12 = _slicedToArray(_numbers$slice11, 1),
        _y3 = _numbers$slice12[0];
      points.push([lastPoint[0], lastPoint[1] + _y3]);
    }
  });
  return points;
};
var getPointsSize = function getPointsSize(points) {
  var xmax = 0,
    ymax = 0,
    xmin = 0,
    ymin = 0;
  points.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      x = _ref2[0],
      y = _ref2[1];
    if (x > xmax) {
      xmax = x;
    }
    if (y > ymax) {
      ymax = y;
    }
    if (x < xmin) {
      xmin = x;
    }
    if (y < ymin) {
      ymin = y;
    }
  });
  return [xmax - xmin, ymax - ymin];
};
var canvasRef = {};
var getCanvasContext = function getCanvasContext() {
  var context;
  if (canvasRef.context) {
    context = canvasRef.context;
  } else {
    var _document;
    var canvas = (_document = document) === null || _document === void 0 ? void 0 : _document.createElement('canvas');
    if (!canvas) {
      return null;
    }
    context = canvas.getContext('2d');
    if (context) {
      canvasRef.canvas = canvas;
      canvasRef.context = context;
    }
  }
  return context;
};
var getTextSize = function getTextSize(text, attrs) {
  var textArr = text.split('\n');
  var height = (attrs.fontSize || 12) * textArr.length * (attrs.lineHeight || 1);
  // Try to get canvas to measure text
  var context = getCanvasContext();
  if (context) {
    context.font = "".concat(attrs.fontWeight || 'normal', " ").concat(attrs.fontSize || 12, "px ").concat(attrs.fontFamily || '');
    var width = 0;
    for (var i = 0; i < textArr.length; i += 1) {
      width = Math.max(width, context.measureText(textArr[i]).width);
    }
    return [width * (attrs.fontSize || 12) / 10, height];
  }
  // fallback solution
  return [Math.max.apply(Math, textArr.map(function (str) {
    return str.length * (attrs.fontSize || 12);
  })), height];
};
var getSizeOfShape = function getSizeOfShape(type, attrs) {
  switch (type) {
    case 'rect':
    case 'image':
      return {
        type: type,
        width: Number(attrs.width) || 0,
        height: Number(attrs.height) || 0
      };
    case 'circle':
    case 'marker':
      return {
        type: type,
        width: (attrs.r || 0) * 2,
        height: (attrs.r || 0) * 2
      };
    case 'ellipse':
      return {
        type: type,
        width: (attrs.rx || 0) * 2,
        height: (attrs.ry || 0) * 2
      };
    case 'path':
      var pathSize = getPointsSize(convertPathToPoints(attrs.path || []));
      return {
        type: type,
        width: pathSize[0],
        height: pathSize[1]
      };
    case 'polygon':
      var polygonSize = getPointsSize(attrs.points || []);
      return {
        type: type,
        width: polygonSize[0],
        height: polygonSize[1]
      };
    case 'text':
      var textSize = getTextSize(attrs.text || '', attrs);
      return {
        type: type,
        width: textSize[0],
        height: textSize[1]
      };
    default:
      return {
        type: type,
        width: 0,
        height: 0
      };
  }
};

var LayoutAlignMap = {
  auto: ALIGN_AUTO,
  baseline: ALIGN_BASELINE,
  center: ALIGN_CENTER,
  'flex-end': ALIGN_FLEX_END,
  'flex-start': ALIGN_FLEX_START,
  'space-around': ALIGN_SPACE_AROUND,
  'space-between': ALIGN_SPACE_BETWEEN,
  stretch: ALIGN_STRETCH
};
var DisplayMap = {
  none: DISPLAY_NONE,
  flex: DISPLAY_FLEX
};
var FlexDirectionMap = {
  column: FLEX_DIRECTION_COLUMN,
  'column-reverse': FLEX_DIRECTION_COLUMN_REVERSE,
  row: FLEX_DIRECTION_ROW,
  'row-reverse': FLEX_DIRECTION_ROW_REVERSE
};
var FlexWrapMap = {
  'no-wrap': WRAP_NO_WRAP,
  wrap: WRAP_WRAP,
  'wrap-reverse': WRAP_WRAP_REVERSE
};
var JustifyContentMap = {
  center: JUSTIFY_CENTER,
  'flex-end': JUSTIFY_FLEX_END,
  'flex-start': JUSTIFY_FLEX_START,
  'space-around': JUSTIFY_SPACE_AROUND,
  'space-between': JUSTIFY_SPACE_BETWEEN,
  'space-evenly': JUSTIFY_SPACE_EVENLY
};

var _excluded$a = ["container"];
var getFourFromNumOrArr = function getFourFromNumOrArr(target) {
  if (target instanceof Array) {
    switch (target.length) {
      case 1:
        var m = target[0];
        return [m, m, m, m];
      case 2:
        var _target = _slicedToArray(target, 2),
          tb = _target[0],
          lr = _target[1];
        return [tb, lr, tb, lr];
      case 3:
        var _target2 = _slicedToArray(target, 3),
          t = _target2[0],
          lar = _target2[1],
          b = _target2[2];
        return [t, lar, b, lar];
      case 4:
        return target;
      default:
        return [0, 0, 0, 0];
    }
  } else {
    return [target, target, target, target];
  }
};
var constructYogaNode = function constructYogaNode(node) {
  var yogaNode = Node.create();
  var style = node.attrs;
  if (style.position === 'absolute') {
    yogaNode.setWidth(0);
    yogaNode.setHeight(0);
    return yogaNode;
  }
  if (style.alignContent) {
    yogaNode.setAlignContent(LayoutAlignMap[style.alignContent]);
  }
  if (style.alignItems) {
    yogaNode.setAlignItems(LayoutAlignMap[style.alignItems]);
  }
  if (style.alignSelf) {
    yogaNode.setAlignSelf(LayoutAlignMap[style.alignSelf]);
  }
  if (style.display) {
    yogaNode.setDisplay(DisplayMap[style.display]);
  } else {
    yogaNode.setDisplay(DisplayMap['flex']);
  }
  if (style.flex) {
    yogaNode.setFlex(style.flex);
  }
  if (style.flexBasis) {
    yogaNode.setFlexBasis(style.flexBasis);
  }
  if (style.flexGrow) {
    yogaNode.setFlexGrow(style.flexGrow);
  }
  if (style.flexShrink) {
    yogaNode.setFlexShrink(style.flexShrink);
  }
  if (style.flexDirection) {
    yogaNode.setFlexDirection(FlexDirectionMap[style.flexDirection]);
  }
  if (style.flexWrap) {
    yogaNode.setFlexWrap(FlexWrapMap[style.flexWrap]);
  }
  if (style.justifyContent) {
    yogaNode.setJustifyContent(JustifyContentMap[style.justifyContent]);
  }
  if (style.maxHeight) {
    yogaNode.setMaxHeight(style.maxHeight);
  }
  if (style.minHeight) {
    yogaNode.setMinHeight(style.minHeight);
  }
  if (style.maxWidth) {
    yogaNode.setMaxWidth(style.maxWidth);
  }
  if (style.minWidth) {
    yogaNode.setMinWidth(style.minWidth);
  }
  if (style.height) {
    if (style.height === 'auto') {
      yogaNode.setHeightAuto();
    } else {
      yogaNode.setHeight(style.height);
    }
  }
  if (style.width) {
    if (style.width === 'auto') {
      yogaNode.setWidthAuto();
    } else {
      yogaNode.setWidth(style.width);
    }
  }
  if (style.margin) {
    var marginArray = getFourFromNumOrArr(style.margin);
    if (marginArray[0] === 'auto') {
      yogaNode.setMarginAuto(Yoga__default.EDGE_TOP);
    } else {
      yogaNode.setMargin(Yoga__default.EDGE_TOP, Number(marginArray[0]));
    }
    if (marginArray[1] === 'auto') {
      yogaNode.setMarginAuto(Yoga__default.EDGE_RIGHT);
    } else {
      yogaNode.setMargin(Yoga__default.EDGE_RIGHT, Number(marginArray[1]));
    }
    if (marginArray[2] === 'auto') {
      yogaNode.setMarginAuto(Yoga__default.EDGE_BOTTOM);
    } else {
      yogaNode.setMargin(Yoga__default.EDGE_BOTTOM, Number(marginArray[2]));
    }
    if (marginArray[3] === 'auto') {
      yogaNode.setMarginAuto(Yoga__default.EDGE_LEFT);
    } else {
      yogaNode.setMargin(Yoga__default.EDGE_LEFT, Number(marginArray[3]));
    }
  }
  if (style.padding) {
    var paddingArray = getFourFromNumOrArr(style.padding);
    yogaNode.setPadding(Yoga__default.EDGE_TOP, paddingArray[0]);
    yogaNode.setPadding(Yoga__default.EDGE_RIGHT, paddingArray[1]);
    yogaNode.setPadding(Yoga__default.EDGE_BOTTOM, paddingArray[2]);
    yogaNode.setPadding(Yoga__default.EDGE_LEFT, paddingArray[3]);
  }
  return yogaNode;
};
var constructNodes = function constructNodes(root, basicContainer) {
  var childrenArr = [[root]];
  var parentArr = [];
  var resultNode = null;
  while (childrenArr[0]) {
    var children = childrenArr.pop() || [];
    var parent = parentArr.pop();
    var newChildren = [];
    for (var i = 0; i < (children === null || children === void 0 ? void 0 : children.length); i += 1) {
      var node = children[i];
      var size = getSizeOfShape(node.type, node.attrs);
      if (!node.attrs.width) {
        node.attrs.width = size.width || 0;
      }
      if (!node.attrs.height) {
        node.attrs.height = size.height || 0;
      }
      var containerNode = _objectSpread2(_objectSpread2({}, node), {}, {
        container: constructYogaNode(node),
        children: []
      });
      if (node.children.length) {
        parentArr.push(containerNode);
        childrenArr.push(node.children);
      }
      newChildren.push(containerNode);
    }
    if (!parent) {
      resultNode = newChildren[0];
      basicContainer.insertChild(newChildren[0].container, 0);
    } else {
      parent.children = newChildren;
      for (var j = 0; j < parent.children.length; j += 1) {
        parent.container.insertChild(parent.children[j].container, j);
      }
    }
  }
  return resultNode;
};
var calculateNodes = function calculateNodes(node, parentBoundaryBox) {
  var boundaryBox = {
    width: Number(node.attrs.width) || 0,
    height: Number(node.attrs.height) || 0,
    x: 0,
    y: 0
  };
  var actualBondary = _objectSpread2({}, boundaryBox);
  var container = node.container,
    restNode = _objectWithoutProperties(node, _excluded$a);
  if (restNode.attrs.position === 'absolute') {
    boundaryBox.x = restNode.attrs.x;
    boundaryBox.y = restNode.attrs.y;
    actualBondary = boundaryBox;
  } else if (container) {
    var layout = container.getComputedLayout();
    boundaryBox.width = layout.width;
    boundaryBox.height = layout.height;
    boundaryBox.x = layout.left + parentBoundaryBox.x;
    boundaryBox.y = layout.top + parentBoundaryBox.y;
    actualBondary = _objectSpread2({}, boundaryBox);
    if (['circle', 'ellipse'].includes(restNode.type)) {
      boundaryBox.x += boundaryBox.width / 2;
      boundaryBox.y += boundaryBox.height / 2;
    }
    if (restNode.type === 'text') {
      boundaryBox.y += boundaryBox.height;
    }
  }
  var children = [];
  for (var i = 0; i < restNode.children.length; i += 1) {
    children.push(calculateNodes(restNode.children[i], actualBondary));
  }
  return _objectSpread2(_objectSpread2({}, restNode), {}, {
    attrs: _objectSpread2(_objectSpread2({}, restNode.attrs), boundaryBox),
    children: children,
    boundaryBox: boundaryBox
  });
};
var getPositionUsingYoga = function getPositionUsingYoga(root) {
  var basicContainer = Node.create();
  // init container
  basicContainer.setWidthAuto();
  basicContainer.setHeightAuto();
  var newNodes = constructNodes(root, basicContainer) || _objectSpread2(_objectSpread2({}, root), {}, {
    container: basicContainer
  });
  basicContainer.calculateLayout();
  var result = calculateNodes(newNodes, {
    width: 0,
    height: 0,
    x: 0,
    y: 0
  });
  basicContainer.freeRecursive();
  return result;
};

var getRatioByArray = function getRatioByArray(arr, ratio) {
  var usingArr = [];
  arr.forEach(function (item) {
    if (item[0] instanceof Array) {
      item[0].forEach(function (subR) {
        return usingArr.push([subR, item[1]]);
      });
    } else {
      usingArr.push([Number(item[0]), item[1]]);
    }
  });
  usingArr = usingArr.sort(function (a, b) {
    return a[0] - b[0];
  });
  for (var i = 0; i < usingArr.length; i++) {
    var now = usingArr[i];
    var next = usingArr[i + 1];
    if (!next) {
      return now[1];
    }
    if (ratio > now[0] && ratio <= next[0]) {
      var deltaRatio = ratio - now[0];
      var allRatio = next[0] - now[0];
      var deltaVal = next[1] - now[1];
      return now[1] + deltaVal * deltaRatio / allRatio;
    }
  }
};
var animations = {
  spin: function spin(ratio) {
    var toMatrix = Util.transform([1, 0, 0, 0, 1, 0, 0, 0, 1], [['r', Math.PI * 2 * ratio]]);
    return {
      matrix: toMatrix
    };
  },
  flash: function flash(ratio) {
    return {
      opacity: Math.abs(1 - ratio * 2)
    };
  },
  pulse: function pulse(ratio) {
    var uRatio = getRatioByArray([[[0, 1], 1], [0.5, 1.25]], ratio);
    var toMatrix = Util.transform([1, 0, 0, 0, 1, 0, 0, 0, 1], [['s', uRatio, uRatio]]);
    return {
      matrix: toMatrix
    };
  },
  rubber: function rubber(ratio) {
    var xratio = getRatioByArray([[0, 1], [0.3, 1.25], [0.4, 0.75], [0.5, 1.15], [0.65, 0.95], [0.75, 1.05], [1, 1]], ratio);
    var yratio = getRatioByArray([[0, 1], [0.3, 0.75], [0.4, 1.25], [0.5, 0.95], [0.65, 1.05], [0.75, 0.95], [1, 1]], ratio);
    var toMatrix = Util.transform([1, 0, 0, 0, 1, 0, 0, 0, 1], [['s', xratio, yratio]]);
    return {
      matrix: toMatrix
    };
  },
  tada: function tada(ratio) {
    var scaleRatio = getRatioByArray([[0, 1], [[0.1, 0.2], 0.9], [[0.8, 0.9], 1.1], [1, 1]], ratio);
    var tadaRatio = getRatioByArray([[0, 0], [[0.3, 0.5, 0.7, 0.9], 1], [[0.1, 0.2, 0.4, 0.6, 0.8], -1], [1, 0]], ratio);
    var toMatrix = Util.transform([1, 0, 0, 0, 1, 0, 0, 0, 1], [['s', scaleRatio, scaleRatio], ['r', (tadaRatio || 0) * Math.PI / 60]]);
    return {
      matrix: toMatrix
    };
  },
  bounce: function bounce(ratio) {
    var yNum = getRatioByArray([[[0, 1], 0], [[0.4, 0.43], -30], [0.7, -15], [0.8, 10], [0.9, -3]], ratio);
    var scaleY = getRatioByArray([[[0, 1], 1], [[0.4, 0.43], 1.1], [0.7, 1.05], [0.8, 0.95], [0.9, 1.02]], ratio);
    var toMatrix = Util.transform([1, 0, 0, 0, 1, 0, 0, 0, 1], [['t', 0, yNum], ['s', 1, scaleY]]);
    return {
      matrix: toMatrix
    };
  }
};

var animateShapeWithConfig = function animateShapeWithConfig(shape, config, initMatrix) {
  var animateFunc = (config === null || config === void 0 ? void 0 : config.animate) && animations[config.animate];
  if (config && animateFunc) {
    var cfg = _objectSpread2(_objectSpread2({
      duration: 2000
    }, config), {}, {
      initMatrix: initMatrix
    });
    shape.animate(animateFunc, cfg);
  } else {
    shape.stopAnimate();
  }
};

var registerNodeReact = function registerNodeReact(el) {
  var result = getShapeFromReact(el);
  var target = getPositionUsingYoga(result);
  return target;
};
var renderTarget = function renderTarget(target, group) {
  var g = group;
  var keyshape = group;
  var _target$attrs = target.attrs,
    attrs = _target$attrs === void 0 ? {} : _target$attrs,
    boundaryBox = target.boundaryBox,
    type = target.type,
    children = target.children,
    props = target.props;
  if (target.type !== 'group') {
    var shape = group.addShape(target.type, _objectSpread2({
      attrs: attrs,
      origin: {
        boundaryBox: boundaryBox,
        type: type,
        children: children
      }
    }, props));
    if (props.keyShape) {
      keyshape = shape;
    }
    animateShapeWithConfig(shape, props.animation);
  } else {
    g = group.addGroup(props);
    if (!keyshape) {
      keyshape = g;
    }
  }
  if (target.children) {
    var keyshapes = target.children.map(function (n) {
      return renderTarget(n, g);
    }).filter(function (e) {
      return e;
    });
    keyshape = keyshapes.find(function (shape) {
      return !shape.isGroup();
    }) || keyshape;
  }
  return keyshape;
};
var getRealStructure = function getRealStructure(target) {
  var children = target.children;
  target.children = [];
  var realChildren = [];
  for (var i = 0; i < children.length; i += 1) {
    var result = getRealStructure(children[i]);
    realChildren = realChildren.concat(result);
  }
  if (target.type !== 'group') {
    return [target].concat(_toConsumableArray(realChildren));
  } else {
    target.children = realChildren;
    return [target];
  }
};
var diffTarget = function diffTarget(container, shapeArr) {
  var childrenList = _toConsumableArray(container.getChildren());
  for (var i = 0; i < childrenList.length; i += 1) {
    var lastShape = childrenList[i];
    var nowShape = shapeArr[i];
    if (!nowShape) {
      container.removeChild(lastShape, true);
    } else if (!lastShape) {
      renderTarget(nowShape, container);
    } else if (lastShape.cfg.type !== nowShape.type) {
      container.removeChild(lastShape, true);
      renderTarget(nowShape, container);
    } else {
      if (nowShape.props) {
        lastShape.cfg = _objectSpread2(_objectSpread2({}, lastShape.cfg), nowShape.props);
      }
      if (nowShape.attrs && lastShape.attr) {
        lastShape.attr(nowShape.attrs);
      }
      if (nowShape.type === 'group') {
        diffTarget(lastShape, nowShape.children);
      }
    }
  }
};
function createNodeFromReact(Component) {
  var compileXML = function compileXML(cfg) {
    return registerNodeReact(React.createElement(Component, {
      cfg: cfg
    }));
  };
  return {
    draw: function draw(cfg, fatherGroup) {
      var resultTarget = compileXML(cfg || {});
      var keyshape = renderTarget(resultTarget, fatherGroup);
      return keyshape;
    },
    update: function update(cfg, node) {
      var resultTarget = compileXML(cfg || {});
      if (node) {
        var nodeGroup = node.getContainer();
        var realTarget = getRealStructure(resultTarget);
        diffTarget(nodeGroup, realTarget);
      }
    },
    getAnchorPoints: function getAnchorPoints() {
      return [[0, 0.5], [1, 0.5], [0.5, 1], [0.5, 0]];
    }
  };
}

var propsToEventMap = {
  click: 'onClick',
  dblclick: 'onDBClick',
  mouseenter: 'onMouseEnter',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseover: 'onMouseOver',
  mouseleave: 'onMouseLeave',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  dragstart: 'onDragStart',
  drag: 'onDrag',
  dragend: 'onDragEnd',
  dragenter: 'onDragEnter',
  dragleave: 'onDragLeave',
  dragover: 'onDragOver',
  drop: 'onDrop',
  contextmenu: 'onContextMenu'
};
function appenAutoShapeListener(graph) {
  Object.entries(propsToEventMap).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      eventName = _ref2[0],
      propName = _ref2[1];
    graph.on("node:".concat(eventName), function (evt) {
      var shape = evt.shape;
      var item = evt.item;
      var graph = evt.currentTarget;
      var func = shape === null || shape === void 0 ? void 0 : shape.get(propName);
      if (func && item) {
        func(evt, item, shape, graph);
      }
    });
  });
}

export { Circle, Ellipse, Group, Image, Marker, Path, Polygon, Rect, Text, appenAutoShapeListener, createNodeFromReact };
